import OrderOptimizerDetailsUpdateParams, {
  OrderOptimizerDetailsUpdateParamsStatus,
} from "../../../../../common/services/order-optimizer/details/update/order-optimizer-details-update-params";
import { OrderOptimizerTaxiDetailsItemStatus } from "./types/order-optimizer-taxi-details-item";

const createStatus = (
  status: OrderOptimizerTaxiDetailsItemStatus,
): OrderOptimizerDetailsUpdateParamsStatus => {
  switch (status) {
    case OrderOptimizerTaxiDetailsItemStatus.INTERESTING:
      return OrderOptimizerDetailsUpdateParamsStatus.INTERESTING;
    case OrderOptimizerTaxiDetailsItemStatus.PENDING:
      return OrderOptimizerDetailsUpdateParamsStatus.PENDING;
    case OrderOptimizerTaxiDetailsItemStatus.REJECTED:
      return OrderOptimizerDetailsUpdateParamsStatus.REJECTED;
  }
};

const create = (
  id: string,
  status: OrderOptimizerTaxiDetailsItemStatus,
): OrderOptimizerDetailsUpdateParams => {
  return {
    id: id,
    status: createStatus(status),
  };
};

const orderOptimizerTaxiDetailsUpdateParamsFactory = {
  create,
};

export default orderOptimizerTaxiDetailsUpdateParamsFactory;
